<template lang="pug">
section
  s-page-title(
    :previous='true',
    :title='id ? "Редактирование статьи" : "Добавление статьи"'
  )
  v-card
    v-tabs(color='dark', slider-color='primary')
      v-tab Осноновное
      v-tab-item(:transition='false', :reverse-transition='false')
        v-container(grid-list-xl, fluid)
          v-layout(wrap)
            v-flex(xs12, sm12)
              .picker
                s-publish-date-status(:errors='errors', :model='item')
            v-flex(xs12)
              v-text-field(
                :error='errors.has("name")',
                :error-messages='errors.first("name")',
                v-model='item.name',
                label='Название статьи'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("annotation")',
                :error-messages='errors.first("annotation")',
                v-model='item.annotation',
                label='Краткое описание (annotation)',
                counter
              )
            v-flex(xs6, style='max-width: 50%', v-if='attributes.regions')
              v-select(
                :items='attributes.regions',
                v-model='regionsIds',
                item-value='id',
                item-text='region_name',
                label='Регион',
                multiple,
                clearable
              )
            v-flex(xs6, style='max-width: 50%', v-if='attributes.categories')
              v-select(
                :items='attributes.categories',
                v-model='category',
                item-value='id',
                item-text='name',
                label='Категория',
                returnObject,
                clearable
              )
            v-flex(xs6, style='max-width: 50%', v-if='attributes.complexes')
              v-select(
                :items='attributes.complexes',
                v-model='complexesIds',
                item-value='id',
                item-text='name',
                label='Жилые комплексы',
                multiple,
                clearable
              )
            v-flex(xs6, style='max-width: 50%', v-if='attributes.categories')
              v-select(
                :items='attributes.categories',
                v-model='categoryIds',
                item-value='id',
                item-text='name',
                label='Дополнительные категории',
                multiple,
                clearable
              )
            v-flex(xs12, v-if='attributes.faqgroups')
              v-select(
                :error='errors.has("faqgroup_id")',
                :error-messages='errors.first("faqgroup_id")',
                :items='attributes.faqgroups',
                v-model='faqgroup',
                item-text='name',
                item-value='id',
                label='Группа FAQ',
                returnObject,
                clearable
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("meta_title")',
                :error-messages='errors.first("meta_title")',
                v-model='item.meta_title',
                label='Название страницы (title страницы)'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("meta_h1")',
                :error-messages='errors.first("meta_h1")',
                v-model='item.meta_h1',
                label='Заголовок страницы (h1 страницы)'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("meta_description")',
                :error-messages='errors.first("meta_description")',
                v-model='item.meta_description',
                label='Краткое описание (description страницы)',
                counter
              )
            v-flex(xs12)
              s-slug-input(:model='item')
            v-flex(xs6)
              s-auto-image-upload(
                v-model='item.picture',
                :src='item.picture_url',
                :parseResponse='(r) => r.hash',
                label='Титульная картинка для блога',
                hint='Допустимые форматы: jpg, png, gif, svg (рекомендуемый размер 742х418)'
              )
      v-tab(v-if='id && item.content_type === "html-data"') Контент
      v-tab-item(:transition='false', :reverse-transition='false')
        v-card-text(:key='content.length')
          blocks(:blocksList='content', @change='updateContent')
    v-card-actions.large
      v-spacer
      s-back-btn
      v-btn(@click='save', :loading='isLoading', color='primary', depressed) Сохранить
</template>

<script>
import http from '@/http'
import Blocks from '@/modules/blocks/components/List'
import { get, defaultTo } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: { Blocks },

  data: () => ({
    item: {},
    attributes: {},
  }),

  async created() {
    if (this.id) {
      const res = await this.fetchSingle({ id: this.id })
      this.item = res.data
    }
    this.fetchAttributes()
  },

  methods: {
    async save() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.item,
          })
        } else {
          await this.create({ data: this.item })
          this.$router.push({ name: 'Seo.Blog' })
        }
        this.$root.showSnack('Сохранено')
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/seo/blogs/attributes')
        this.attributes = res.data
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки справочников')
      }
    },

    updateContent(content) {
      this.content = content
    },

    ...mapActions('seo/blog', ['fetchSingle', 'update', 'create']),
  },

  computed: {
    content: {
      get() {
        if (!this.item.content) return []
        return JSON.parse(this.item.content)
      },
      set(val) {
        this.item.content = JSON.stringify(val)
      },
    },
    category: {
      get() {
        return this.item.category_id
      },
      set(val) {
        const category_id = get(val, 'id', null)
        this.item.category_id = category_id
      },
    },

    categoryIds: {
      get() {
        const categories = defaultTo(get(this, 'item.category_ids'), '')
        return categories.split(/,/)
      },
      set(val) {
        const categories = val.join(',')
        this.item.category_ids = categories
      },
    },

    regionsIds: {
      get() {
        const regions = defaultTo(get(this, 'item.regions'), '')
        return regions.split(/,/)
      },
      set(val) {
        const regions = val.join(',')
        this.item.regions = regions
      },
    },

    complexesIds: {
      // prettier-ignore
      get() {
        const complexes = defaultTo(get(this, 'item.complex_ids'), '')
        return complexes.split(/,/).map((v) => Number(v)).filter(Boolean)
      },
      set(val) {
        const complexes = val.join(',')
        this.item.complex_ids = complexes
      },
    },

    faqgroup: {
      get() {
        return this.item.faqgroup_id
      },
      set(val) {
        const faqgroup = get(val, 'id', null)
        this.item.faqgroup_id = faqgroup
      },
    },

    ...mapGetters('seo/blog', ['isLoading']),
  },
}
</script>

<style scoped>
</style>
